/**
 * @license
 * Copyright 2017 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { verifyEnumString } from './json';
import { NullarySignal } from './signal';
export class TrackableEnum {
    constructor(enumType, value_, defaultValue = value_) {
        this.enumType = enumType;
        this.value_ = value_;
        this.defaultValue = defaultValue;
        this.changed = new NullarySignal();
    }
    set value(value) {
        if (this.value_ !== value) {
            this.value_ = value;
            this.changed.dispatch();
        }
    }
    get value() {
        return this.value_;
    }
    reset() {
        this.value = this.defaultValue;
    }
    restoreState(obj) {
        this.value = verifyEnumString(obj, this.enumType);
    }
    toJSON() {
        if (this.value_ === this.defaultValue) return undefined;
        return this.enumType[this.value_].toLowerCase();
    }
}
//# sourceMappingURL=trackable_enum.js.map